import { LocalContentProps } from "~/sdks/LocalContent/types";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import React, { lazy } from "react";
import { useStateManagerContext } from "~/context/stateManager";
import errorTracker from "~/utils/errorTracker";
import { AnalyticsEvents, useTracking } from "@local-logic/core/tracking";
import useEffectOnce from "~/hooks/useEffectOnce";

const GoogleMap = lazy(() => import("./GoogleMap"));
const MapGLMap = lazy(() => import("./MapGLMap"));

const Map = () => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const tracking = useTracking();

  useEffectOnce(() => {
    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.VIEWED,
    });
  });

  const googleMapRender = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return <></>;
      case Status.FAILURE:
        return <></>;
      case Status.SUCCESS:
        return <GoogleMap />;
      default:
        return <></>;
    }
  };

  if (sdkState.options?.mapProvider?.name === "google") {
    const googleApiKey = sdkState.options.mapProvider.key;

    if (!googleApiKey) {
      const e = new Error("A map provider key is required in this case.");
      errorTracker.captureException(e);
      throw e;
    }

    return (
      <Wrapper
        apiKey={googleApiKey || ""}
        libraries={["geometry", "places"]}
        render={googleMapRender}
      />
    );
  }

  return <MapGLMap />;
};

export default Map;
